import React from 'react';
import HomeSection from '../Home/HomeSection';
import HomeClients from '../Home/sections/HomeClients';
import SocialLinks from '../components/SocialLinks';
import ContactForm from './ContactForm';
import Map from './Map';
import { PROJECT_UPDATES } from './contactData';
import {
  CONTACT_ADDRESS,
  CONTACT_EMAILS,
  CONTACT_PHONES,
} from '../constants/site';
import '../Content/firstpage.css';
import '../Home/Home.css';
import './contact.css';

const Contact = () => (
  <>
    <div className="wrapper-news contact-page">
      <div className="grid-container">
        <div className="super-grid-left">
          <div className="grid-box-1 grid-color">
            <div className="heading contact">
              <h4>Contact us</h4>
              <div className="line"></div>
              <p>
                Vientiane Traffic is more than a business; it&apos;s a commitment to safety,
                innovation, and quality. For inquiries, collaborations, or to explore how we can
                meet your specific needs, reach out to us at the following contact details:
              </p>
            </div>

            <div className="grid-1-form">
              <ContactForm />
              <Map />
            </div>
          </div>

          <div className="grid-box-2 grid-color">
            <div className="heading">
              <h4>Contact information below:</h4>
              <div className="line"></div>
            </div>

            <div className="grid-2-row contact-info-row">
              <div className="grid-2-col">
                <i className="fas fa-envelope"></i>
                <h4>Email</h4>
                <p>
                  {CONTACT_EMAILS.map((email) => (
                    <React.Fragment key={email}>
                      {email}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
              <div className="grid-2-col">
                <i className="fas fa-phone"></i>
                <h4>Phone</h4>
                <p>
                  {CONTACT_PHONES.map((phone) => (
                    <React.Fragment key={phone}>
                      Tel: {phone}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
              <div className="grid-2-col">
                <i className="fas fa-map-marked-alt"></i>
                <h4>Address</h4>
                <p>{CONTACT_ADDRESS}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="super-grid-right">
          <div className="grid-box-9 grid-color">
            <div className="heading">
              <h4>FOLLOW US</h4>
              <div className="line"></div>
            </div>
            <SocialLinks />
          </div>

          <div className="grid-box-10 grid-color">
            <div className="heading">
              <h4>SERVICE LATEST PROJECT</h4>
              <div className="line"></div>
            </div>

            <div className="grid-10-img">
              <img src={PROJECT_UPDATES[0].image} alt={PROJECT_UPDATES[0].title} />
            </div>

            <div className="grid-10-item">
              <div className="grid-6-item-content">
                <h5>{PROJECT_UPDATES[0].title}</h5>
                <h6>{PROJECT_UPDATES[0].date}</h6>
              </div>
            </div>

            {PROJECT_UPDATES.slice(1).map((update, index) => (
              <div key={index} className="grid-10-item">
                <div className="grid-10-item-img">
                  <img src={update.images[0]} alt="Project update" />
                </div>
                <div className="grid-6-item-content">
                  <div className="grid-10-item-img">
                    <img src={update.images[1]} alt="Project update" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    <div className="contact-clients">
      <HomeSection
        id="clients"
        eyebrow="Trusted by"
        title="Our clients"
        description="Partnering with public agencies and businesses across Laos."
        fullBleed
      >
        <HomeClients />
      </HomeSection>
    </div>
  </>
);

export default Contact;
